module.exports = __webpack_public_path__ + "img/Priest-human-m-70.fa61c51f.gif";